import { h, Component } from 'preact'
import Header from '../../control-components/header'
import CustomCss from '../custom-css/customCss'

interface Props {
  content: string,
  currentUrl: string
}

class CustomCssWrapper extends Component<Props> {
  render ({content, currentUrl} : Props) {
    return (
      <div> 
        <Header
          title = 'Custom CSS'
          disableCancelButton
          disableSaveButton
          customButtons={[
            {
              title: 'Cancel',
              variant: 'secondary',
              url: currentUrl
            },
            {
            title: 'Save changes',
            variant: 'success',
            action: 'js-submit-custom-css'
          }]}
          />
        <CustomCss content={content} />
      </div>  
      )
    }
  }
  
  export default CustomCssWrapper
